import ErrorBoundary from './ErrorBoundary';

export { type ErrorBoundaryProps } from './ErrorBoundary';
export default ErrorBoundary;
